<div class="sol"><div class="container">
<div class="row">

    <div class="col-md-6">
        <div class="sol-box">
<h1>Grow your people, grow <br> your business</h1>
<p>We are a group of experienced retail professionals whose mission is <br> to help retailers and vendors grow their retail business by helping <br> themdevelop their People and   We do this by mixing our real <br> timeexperience with professional education to make our <br> solutionsProcesses.</p>
<button>Explore more</button>       
</div>
    </div>
    <div class="col-md-6">
        <div class="sol-img-box">
            <img src="../../../assets/sol/Group 8957.png" alt="">
        </div>
    </div>
</div>
<div class="catogrires">

    <div class="row">
        <div class="col-md-6 ">
            <div class="cato-box c1">
                <img src="../../../assets/sol/Group 16961.png" alt="">
                <h3>Team Building</h3>
                <p>We tailor team building activities to meet your desired <br> objectives. We mix learning with fun and work with your <br> team before the event to ensure that all your individual <br> and organizational goals are reached within your <br> planned budget.</p>
            <button>Show more</button>
            </div>
        </div>
        <div class="col-md-6">
            <div class="cato-box c2">
                <img class="sp1" src="../../../assets/sol/Group 18155.png" alt="">
                <h3> E-Learning</h3>
                <p>We tailor team building activities to meet your desired <br> objectives. We mix learning with fun and work with your <br> team before the event to ensure that all your individual <br> and organizational goals are reached within your <br> planned budget.</p>
            <button>Show more</button>
            </div>
        </div>
        <div class="col-12">
            <div class="cato-box c3">
                <div class="row"><div class="col-md-6"> <img src="../../../assets/sol/Group 17112.png" alt=""></div>
            <div class="col-md-6"> <h3> Assessments</h3>
                <p>We tailor team building activities to meet your desired <br> objectives. We mix learning with fun and work with your <br> team before the event to ensure that all your individual <br> and organizational goals are reached within your <br> planned budget.</p>
            <button>Show more</button></div>
            </div>
               
               
            </div>
        </div>
        <div class="col-md-6">
            <div class="cato-box c4">
                <img src="../../../assets/sol/Group 15635.png" alt="">
                <h3> Content Development</h3>
                <p>We tailor team building activities to meet your desired <br> objectives. We mix learning with fun and work with your <br> team before the event to ensure that all your individual <br> and organizational goals are reached within your <br> planned budget.</p>
            <button>Show more</button>
            </div>
        </div>
        <div class="col-md-6">
            <div class="cato-box c5">
                <img src="../../../assets/sol/Group 18322.png" alt="">
                <h3 class="sp2"> Consulting</h3>
                <p>We tailor team building activities to meet your desired <br> objectives. We mix learning with fun and work with your <br> team before the event to ensure that all your individual <br> and organizational goals are reached within your <br> planned budget.</p>
            <button>Show more</button>
            </div>
        </div>
        
    </div>
</div>

</div></div>


<div class="container">
    <div class="bites">
      <div class="row">
      <div class="col-md-7">
        <h1>If your business needs <br> solutions</h1>
      <button>Get in Touch</button>
  
      </div>
    <div class="col-md-5">
      <div class="image">
  <img src="../../../assets/sol/Group 12594.png" alt="">
      </div>
    </div>
    </div>
    </div>
  </div>